export const LOAD_CONSULT_SOAT = "LOAD_CONSULT_SOAT";
export const SUCCESS_CONSULT_SOAT = "SUCCESS_CONSULT_SOAT";
export const ERROR_CONSULT_SOAT = "ERROR_CONSULT_SOAT";

export const SUCCESS_CONSULT_SOAT_PRINT = "SUCCESS_CONSULT_SOAT_PRINT";
